import { render, staticRenderFns } from "./TableSettingsPresets.vue?vue&type=template&id=ab1fd21e"
import script from "./TableSettingsPresets.vue?vue&type=script&lang=js"
export * from "./TableSettingsPresets.vue?vue&type=script&lang=js"
import style0 from "./TableSettingsPresets.vue?vue&type=style&index=0&id=ab1fd21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports